import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import {
    isString,
} from '@/lib/utils';

if (process.env.NODE_ENV === 'production' && String(process.env.RO_ENABLE_SENTRY) === 'true') {
    Sentry.init({
        // 项目的地址，用于收集错误信息的 sentry 分配的地址
        dsn: 'https://e77786a94f9447679c3e420f8f91db8b@o314036.ingest.sentry.io/5735996',
        // Vue集成Sentry
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
        // 过滤一些错误
        beforeSend(event, hint) {
            // 502: 各个接口都存在502的问题，暂时先屏蔽，避免占用过多资源
            const filterMessageList = [ 'WeixinJSBridge is not defined', 'Network Error', 'status code 502', 'onunhandledrejection', 'Non-Error promise rejection', 'unhandledrejection', 'Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type' ];
            let eventMessage: string | undefined;
            if (event) {
                eventMessage = event.message;
            }
            if ((eventMessage || '').startsWith('Non-Error promise rejection') && hint && hint.originalException) {
                return null;
            }
            if (hint) {
                if (hint.originalException) {
                    const exception = hint.originalException;
                    if (isString(exception)) {
                        eventMessage = exception;
                    } else {
                        eventMessage = exception.message;
                    }
                }
            }
            if (eventMessage) {
                for (let i = 0, len = filterMessageList.length; i < len; i++) {
                    if (eventMessage.indexOf(filterMessageList[i]) >= 0) {
                        return null;
                    }
                }
            }
            return event;
        },
        ignoreErrors: ['Non-Error promise rejection captured with keys: currentTarget, isTrusted, target, type'],
    });
}
